export default "__VITE_ASSET__baa94657__"